import DetailService from '../../components/DetailService';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function ConseilHandicap() {
    return (
     <div>
        <Header/>
        <DetailService
            titre="Conseil en accessibilité et handicap"
            categorie="Conseil"
            image="/images/conseil.avif"
            description="Notre conseil en accessibilité et handicap vise à rendre vos produits et services accessibles à tous. Nos intervenants collaborent avec vos équipes pour s’assurer que vos produits numériques respectent les normes d'accessibilité. Grâce à leur sensibilité aux besoins des personnes en situation de handicap, ils proposent des solutions inclusives garantissant une expérience optimale pour tous les utilisateurs."
            etapes={[
                {
                    numero: 1,
                    titre: 'Cadrage et définition du périmètre',
                    texte: 'Identification des interfaces à évaluer, des profils de handicap concernés et des référentiels applicables (WCAG 2.1, RGAA, EN 301 549). Nous définissons ensemble les objectifs de conformité visés.',
                },
                {
                    numero: 2,
                    titre: 'Audit d\'accessibilité',
                    texte: 'Évaluation technique et fonctionnelle de vos interfaces selon les critères des référentiels retenus : contrastes, navigation clavier, compatibilité avec les lecteurs d\'écran, alternatives textuelles, etc.',
                },
                {
                    numero: 3,
                    titre: 'Tests avec utilisateurs en situation de handicap (optionnel)',
                    texte: 'Sessions de tests avec des utilisateurs réels utilisant des technologies d\'assistance (lecteur d\'écran, clavier seul, etc.) pour compléter l\'audit technique par une évaluation fonctionnelle.',
                },
                {
                    numero: 4,
                    titre: 'Analyse et priorisation',
                    texte: 'Classification des non-conformités par niveau de sévérité et par impact sur les utilisateurs concernés. Priorisation des corrections selon les ressources disponibles et les obligations légales.',
                },
                {
                    numero: 5,
                    titre: 'Restitution et plan d\'action',
                    texte: 'Remise d\'un rapport de conformité détaillé et d\'un plan d\'action priorisé, accompagné de recommandations techniques concrètes pour chaque non-conformité identifiée.',
                },
            ]}
            realisations={[
             
            ]}
        />
          <Footer/>
        </div>
    );
}

export default ConseilHandicap;
